<h1 mat-dialog-title>{{'Upload file' | translate}}</h1>
<div mat-dialog-content>
    <input type="file" accept="application/vnd.ms-excel" (change)="onFileChanged($event)">
</div>

<div mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
        {{'Close' | translate}}
    </button>
    <button mat-raised-button color="primary" [disabled]="!file" (click)="upload()">
        {{'Upload file' | translate}}
    </button>
    &nbsp;
    <ng-container *ngIf="accauntSandbox.importUsersFromFileLoading$ | async">
        <mat-spinner [diameter]="20"></mat-spinner>
    </ng-container>
</div>